<template lang="pug">
  .modal-blocker(v-if="image")
    .modal-lightbox
      img(:src="image")


    .lightbox-nav.close(@click="close")
      span &Cross;
    .lightbox-nav.left(@click="prev")
      span &larr;
    .lightbox-nav.right(@click="next")
      span &rarr;

</template>

<script>
export default {
  name: 'LightBox',
  props: {
    images: Array,
    selected: Number
  },
  data () {
    return {
      index: this.selected
    }
  },
  mounted () {
  },
  computed: {
    image () {
      return this.images[this.index]
    }
  },
  methods: {
    actions (e) {
      let keyCode = e.keyCode
      if (keyCode === 27) this.close()
      if (keyCode === 39) this.next()
      if (keyCode === 37) this.prev()
    },
    close () {
      document.removeEventListener('keydown', this.actions)
      this.$emit('close')
    },
    next () {
      this.index++
      if (this.index >= this.images.length) {
        this.index = 0
      }
    },
    prev () {
      this.index--
      if (this.index < 0) {
        this.index = this.images.length - 1
      }
    }
  },
  watch: {
    selected (val) {
      this.index = val
      //document.body.classList.add('has-modal')
      document.addEventListener('keydown', this.actions)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  .modal-blocker
    position fixed
    top 0
    right 0
    left 0
    bottom 0
    height 100vh
    width 100vw
    align-items center
    background rgba(0,0,0,.5)
    display flex
    justify-content center
    overflow scroll
    .modal-lightbox
      //background-color #fff
      max-width 80%
      max-height 80%
      text-align center
      //margin-bottom 10vh
      img
        max-height inherit
        max-width inherit
        
    .lightbox-nav
      background-color #fff
      cursor pointer
      opacity .75
      position fixed
      top 48%
      text-align center
      height 40px
      width 40px
      &:hover
        opacity 1
      &.left
        left 0
      &.right
        right 0
      &.close
        top 0
        right 0
      span
        font-size 26px
      
</style>
